import React from 'react';
import { buildClassNames } from '../../../utils';

import './index.scss';

export const Row: React.FC<React.ComponentProps<'div'>> = ({ className = '', ...props }) => {
  const classNames = buildClassNames('grid__row', className);
  return <div className={classNames} {...props} />;
};
